import { useState } from "react";
import { Link } from "react-router-dom";
import { AuthShell } from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import client, { apiError } from "@/lib/api";

export default function Forgot() {
    const [email, setEmail] = useState("");
    const [sent, setSent] = useState(false);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            await client.post("/auth/forgot-password", { email: email.trim() });
            setSent(true);
        } catch (err) {
            setError(apiError(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <AuthShell
            title="Recupera tu contraseña"
            subtitle="Escríbenos tu correo y te enviaremos un enlace para elegir una nueva. Caduca en una hora."
            footer={
                <Link to="/acceder" className="font-medium text-terracotta hover:underline">
                    Volver a entrar
                </Link>
            }
        >
            {sent ? (
                <div data-testid="forgot-success" className="rounded-lg border border-line bg-card p-5">
                    <p className="text-[16px] leading-[1.6] text-ink">
                        Si ese correo tiene una cuenta en MYAVEREN, te acaba de llegar un enlace para cambiar la
                        contraseña. Revisa también la carpeta de spam, por si acaso.
                    </p>
                </div>
            ) : (
                <form onSubmit={submit} className="space-y-5" noValidate>
                    {error && (
                        <div data-testid="forgot-error" className="rounded-lg border border-destructive/30 bg-destructive/5 px-4 py-3 text-[14px] text-destructive">
                            {error}
                        </div>
                    )}
                    <div className="space-y-2">
                        <Label htmlFor="email">Correo electrónico</Label>
                        <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                            data-testid="forgot-email" placeholder="tu@correo.es" required />
                    </div>
                    <Button type="submit" disabled={loading} data-testid="forgot-submit" className="w-full h-11 text-[15px]">
                        {loading ? "Enviando…" : "Enviarme el enlace"}
                    </Button>
                </form>
            )}
        </AuthShell>
    );
}
